export const BEARER_SCHEME = "bearer";
export const MSAUTH_SCHEME = "msauth1.0";
export const DEFAULT_BEARER_EXPIRY = 3600; // in secs
export const DEFAULT_MSAUTH_EXPIRY: number = 3600 * 24; // in secs
export const MIN_TIME_TO_EXPIRY_IN_MILLI_SECOND: number = 60 * 1000; // 1 minute
export const MILLI_SECOND_TO_SECOND_MULTIPLIER = 1000; // 1 sec
export const TIME_BEFORE_EXPIRY_TO_REFRESH_IN_MILLISECONDS: number = 50 * 1000; // try to refresh token 50 seconds before the token expiry
export const MIN_TIME_TO_EXPIRY_IN_MINUTES = 1;
/**
 * SA_20MIN scope constant for consumer mailbox.
 * This scope provides 20-minute access tokens for sensitive account operations.
 */
export const SA_20MIN_SCOPE = "service::outlook.office.com::SA_20MIN";
